import dayjs, { Dayjs } from 'dayjs'

export const dayjsParse = (dateString: string, format: string) => {
  return dayjs(dateString, format)
}

export const dayjsStringify = (date: Dayjs, format: string) => {
  return dayjs(date).format(format)
}
